import { defineStore } from 'pinia'
import { ref } from 'vue'
import { InfoStoreEnum } from '../enums/infoStoreEnum.js'
import { isDebugMode, isEmpty } from '@ipevo-rd/service-web-utils'

/**
 * Info Store
 */
export const useInfoStore = defineStore(InfoStoreEnum.Key, () => {
        // 是否為開發模式
        const isDevMode = ref<boolean | null>(null)
        // 如果開發模式沒有設定，則預設為 false
        if (isEmpty(isDevMode.value)) {
            isDevMode.value = false
        }

        // 會議標題
        const meetTitle = ref<string>('')
        // Session Short ID
        const shortID = ref<string>('')
        // 支援的性別
        const supportGenders = ref(['male', 'female'])
        // 目標性別
        const targetGender = ref<string>('')
        // 支援的翻譯語言
        const supportedTranslationLanguages = ref<string[]>([])
        // 不支持的TTS語言
        const unsupportedTTSLanguages = ref<string[]>([])
        // 目標語言
        const targetLang = ref<string>('')
        // 會議的ID
        const sessionID = ref<string>('')


        /**
         * 設定會議標題
         * @param title {string} 會議標題
         * @return {void}
         */
        const setMeetTitle = (title: string): void => {
            meetTitle.value = title
        }

        /**
         * 設定目標語言
         * @return {void}
         */
        const setTargetLang = (lang: string): void => {
            targetLang.value = lang
        }

        /**
         * 設定Session Short ID
         * @param id {string} Session Short ID
         * @return {void}
         */
        const setShortID = (id: string): void => {
            shortID.value = id
        }

        /**
         * 設定目標性別
         * @param gender {string} 目標性別
         * @return {void}
         */
        const setTargetGender = (gender: string): void => {
            targetGender.value = gender
        }

        /**
         * 設定支援的翻譯語言
         * @param languages {string[]} 支援的翻譯語言列表
         * @return {void}
         */
        const setSupportedTranslationLanguages = (languages: string[]): void => {
            supportedTranslationLanguages.value = languages
        }

        /**
         * 設定不支援的 TTS 語言
         * @param languages {string[]} 不支援的 TTS 語言列表
         * @return {void}
         */
        const setUnsupportedTTSLanguages = (languages: string[]): void => {
            unsupportedTTSLanguages.value = languages
        }

        /**
         * 設定 Session ID
         * @param id {string} Session ID
         * @return {void}
         */
        const setSessionID = (id: string): void => {
            sessionID.value = id
        }

        /**
         * 設定是否為開發模式
         * @param isDev {boolean} 是否為開發模式
         * @return {void}
         */
        const setIsDevMode = (isDev: boolean): void => {
            isDevMode.value = isDev
        }

        return {
            meetTitle,
            shortID,
            supportGenders,
            supportedTranslationLanguages,
            unsupportedTTSLanguages,
            targetLang,
            sessionID,
            targetGender,
            isDevMode,
            setMeetTitle,
            setShortID,
            setTargetGender,
            setSupportedTranslationLanguages,
            setUnsupportedTTSLanguages,
            setTargetLang,
            setSessionID,
            setIsDevMode,
        }
    },
    {
        persist: {
            key: InfoStoreEnum.Key,
            storage: localStorage,
            serializer: {
                serialize: (value: never) => isDebugMode() ? JSON.stringify(value) : window.btoa(encodeURIComponent(JSON.stringify(value))),
                deserialize: (value: never) => isDebugMode() ? JSON.parse(value) : JSON.parse(decodeURIComponent(window.atob(value))),
            },
        },
    } as never,
)
